"use strict";
// partsから必要分のみimport

import "./parts/_button.js";
import "./parts/_drawer.js";
import "./parts/_fixed-viewport.js";
import "./parts/_loading.js";
// import "./parts/_scroll-header.js";
import "./parts/_slider.js";
import { initBottomMenu } from "./parts/_bottomMenu.js";

initBottomMenu();
